import React from "react";

// import ReactWizard from "react-bootstrap-wizard";
import StepWizard from "react-step-wizard";
import "./StageOfSales.css"
import Step1 from "./WizardSteps/Step1SS.js"
import Step2 from "./WizardSteps/Step2SS.js"
import Step3 from "./WizardSteps/Step3SS.js"
import Step4 from "./WizardSteps/Step4SS.js"
import Step5 from "./WizardSteps/Step5SS.js"
import Step6 from "./WizardSteps/Step6SS.js"
import Step7 from "./WizardSteps/Step7SS.js"
import Step8 from "./WizardSteps/Step8SS.js"
import Step9 from "./WizardSteps/Step9SS.js"
import WizardNav from "./components/WizardNav.js"

class Wizard extends React.Component {
    constructor(props){
        super(props)
        this.state={
            step: 1
        }
    }
    
    render() {

        const { client, updateClient } = this.props;

        const steps = [
            {
                stepIcon: "tim-icons icon-single-copy-04",
                component: Step1,
                stepProps: {
                    client,
                    updateClient
                },
            },
            {
                stepIcon: "tim-icons icon-bullet-list-67",
                component: Step2,
                stepProps: {
                    client,
                    updateClient
                },
            },
            {
                stepIcon: "tim-icons icon-upload",
                component: Step3,
                stepProps: {
                    client,
                    updateClient
                },
            },
            {
                stepIcon: "tim-icons icon-single-copy-04",
                component: Step4,
                stepProps: {
                    client,
                    updateClient
                },
            },
            {
                stepIcon: "tim-icons icon-bullet-list-67",
                component: Step5,
                stepProps: {
                    client,
                    updateClient
                },
            },
            {
                stepIcon: "tim-icons icon-upload",
                component: Step6,
                stepProps: {
                    client,
                    updateClient
                },
            },
            {
                stepIcon: "tim-icons icon-upload",
                component: Step7,
                stepProps: {
                    client,
                    updateClient
                },
            },
            {
                stepIcon: "tim-icons icon-upload",
                component: Step8,
                stepProps: {
                    client,
                    updateClient
                },
            },
            {
                stepIcon: "tim-icons icon-upload",
                component: Step9,
                stepProps: {
                    client,
                    updateClient
                },
            }
        ]

        return (
            <StepWizard nav={<WizardNav />}>
                <Step1 {...steps[0].stepProps} />
                <Step2 {...steps[1].stepProps} />
                <Step3 {...steps[2].stepProps} />
                <Step4 {...steps[3].stepProps} />
                <Step5 {...steps[4].stepProps} />
                <Step6 {...steps[5].stepProps} />
                <Step7 {...steps[6].stepProps} />
                <Step8 {...steps[7].stepProps} />
                <Step9 {...steps[8].stepProps} />
            </StepWizard>
        )
    }
}

export default Wizard;
